import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Breadcrumb trail (APG breadcrumb pattern): a `<nav>` landmark holding a
 * row of `<vx-breadcrumb-item>` links, with the current page as the last,
 * non-linked item.
 *
 *   <vx-breadcrumb [ariaLabel]="'Breadcrumb' translation">
 *     <vx-breadcrumb-item link="/incidents">
 *       <vx-icon name="fire" />
 *       Incidents
 *     </vx-breadcrumb-item>
 *     <vx-breadcrumb-item>Critical Server Outage</vx-breadcrumb-item>
 *   </vx-breadcrumb>
 *
 * List semantics come from `role="list"`/`role="listitem"` rather than
 * `<ol>`/`<li>`: the items are element-selector components, so their hosts
 * can never be native list items (same trade-off as vx-tabs' nav markup).
 */
@Component({
  selector: 'vx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block font-brand' },
})
export class VxBreadcrumbComponent {
  /** Accessible name for the navigation landmark, e.g. "Breadcrumb". */
  readonly ariaLabel = input.required<string>();
}
